import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { checkIsContentManagerAsset, checkIsContentManagerPlaylist } from '../types';
import { getContentAsTree, getIdsWithRank, getRankedContentTree } from '.';
export function formatContentManagerPayload(_ref) {
  var content = _ref.content,
    _ref$initialContentId = _ref.initialContentIds,
    initialContentIds = _ref$initialContentId === void 0 ? [] : _ref$initialContentId;
  var contentAsTree = getContentAsTree(content);
  var rankedContentAsTree = getRankedContentTree({
    contentTree: contentAsTree
  });
  var idsAndRank = getIdsWithRank(rankedContentAsTree);
  var patch = content.map(function (item) {
    var changedFields = item.changedFields;
    var patchItem = {
      rank: idsAndRank[item.id]
    };

    // Pass contentId for all playlists, assets and existing sections.
    // New sections are passed through without the (generated) contentId.
    // The real contentId is added in the BE when the section is created.
    if (
    // Assets & Playlists
    item.type !== 'section' ||
    // Already existing section
    item.type === 'section' && initialContentIds.includes(item.id)) {
      patchItem.contentId = item.id;
    }
    var isNewlyAddedContent = !initialContentIds.includes(item.id);
    var wasContentUpdated = changedFields.size > 0;
    if (!(wasContentUpdated || isNewlyAddedContent)) {
      return patchItem;
    }
    patchItem.updatedDetails = {};

    // If item is a newly added content, ensure we set values for any required fields
    if (isNewlyAddedContent) {
      patchItem.updatedDetails.optional = item.optional;
    }
    var isPlaylist = checkIsContentManagerPlaylist(item);
    var isAsset = checkIsContentManagerAsset(item);

    // Add any updated details and their new values
    if (wasContentUpdated) {
      changedFields.forEach(function (field) {
        // The check is here to calm TS 🙃
        if (patchItem.updatedDetails) {
          if ((isAsset || isPlaylist) && field === 'tags') {
            var _item$tags;
            patchItem.updatedDetails.tags = (_item$tags = item.tags) === null || _item$tags === void 0 ? void 0 : _item$tags.map(function (tag) {
              return tag.id;
            });
          } else if (isAsset && field === 'scormSettings') {
            patchItem.updatedDetails.scormAdvancedSettings = item.scormSettings;
          } else if (isAsset && field === 'completionTime') {
            patchItem.updatedDetails.completionTime = item.completionTime;
          } else if (isAsset && field === 'parentId') {
            patchItem.updatedDetails.parent_id = item.parentId;
          } else if (isAsset && field === 'excludeFromAi') {
            patchItem.updatedDetails.excludeFromAi = item.excludeFromAi;
          } else if (isAsset && field === 'subtitles') {
            patchItem.updatedDetails.subtitles = item.subtitles.map(function (subtitle) {
              return subtitle.id;
            });
          } else if (isPlaylist && field === 'hasPlaylistNumbering') {
            patchItem.updatedDetails.playlist_numbering = item.hasPlaylistNumbering;
          } else if (isPlaylist && field === 'topics' && item.topics) {
            patchItem.updatedDetails.topics = item.topics.map(function (topic) {
              return topic.id;
            });
          } else if (isPlaylist && field === 'badge' && item.badge) {
            patchItem.updatedDetails.badge = {
              id: item.badge.id,
              imageId: item.badge.imageId
            };
          } else if ((isPlaylist || isAsset) && field === 'owner' && item.owner !== undefined) {
            var _item$owner;
            patchItem.updatedDetails.ownerId = ((_item$owner = item.owner) === null || _item$owner === void 0 ? void 0 : _item$owner.id) || null;
          } else {
            patchItem.updatedDetails[field] = item[field];
          }
        }
      });
    }
    return patchItem;
  });

  // NOTE: any content NOT passed through with `contentId` (except new sections) & `rank`
  // will be removed from the playlist in the BE
  return patch;
}